export default {
  github: {
    client_id: 'Iv1.d09f858f30eada25',
    oauth_uri: 'https://github.com/login/oauth/authorize',
    redirect_uri: 'https://localhost:8087/oauth/callback'
  }
}
